export default [
  {
    path: '/invite/detail',
    name: 'invite_detail',
    meta: {
      title: '孕橙好友邀请领福利'
    },
    component: () => import('views/invite/detail')
  },
  {
    path: '/invite/record',
    name: 'invite_record',
    meta: {
      title: '邀请成功好友'
    },
    component: () => import('views/invite/record')
  },
  {
    path: '/invite/activity_rule',
    name: 'invite_activity_rule',
    meta: {
      title: '推荐有礼'
    },
    component: () => import('views/invite/activity_rule')
  },
  {
    path: '/invite/result',
    name: 'result',
    meta: {
      title: '推荐孕橙好友邀请领福利有礼'
    },
    component: () => import('views/invite/result')
  },
  {
    path: '/invite/fhrm',
    name: 'result',
    meta: {
      title: '邀请好友下单获免费租期'
    },
    component: () => import('views/invite/fhrm')
  },
]